'use client'

import { useSorting, UseSortingProps } from '../hooks/UseSorting'
import { useInitialSortingFromURL, useSortingQueryParamsInURL } from '../hooks/UseSortingQueryParamsInURL'
import { UseSortingModel } from '../types/Sorting'
import React, { useMemo, createContext } from 'react'

export interface SortingProviderProps extends UseSortingProps, React.HTMLAttributes<HTMLDivElement> {
    /** Keeps the sorted column and its direction in the browser URL so it survives a refresh or a shared link. */
    bindToURL?: boolean
}
export interface SortingProviderModel extends UseSortingModel {}

export const SortingContext = createContext<SortingProviderModel>({} as SortingProviderModel)

export const SortingProvider = ({ initialSorting, bindToURL = true, children }: SortingProviderProps) => {
    const sortingFromURL = useInitialSortingFromURL({ bindToURL, initialSorting })
    const { sorting, sortHandler } = useSorting({ initialSorting: sortingFromURL })

    useSortingQueryParamsInURL({ bindToURL, initialSorting, sorting })

    const SortingProviderData: SortingProviderModel = useMemo(
        () => ({
            sorting,
            sortHandler,
        }),
        [sorting],
    )

    return <SortingContext.Provider value={SortingProviderData}>{children}</SortingContext.Provider>
}
